import workshopThemeUrl from "../assets/phaser-music/workshop-theme.mp3";

export const GAME_AUDIO = {
  workshopTheme: {
    key: "diamond-tapper-workshop-theme-v1",
    url: workshopThemeUrl,
    volume: 0.48,
  },
} as const;
